module.exports = __webpack_public_path__ + "img/ceo.309d8634.svg";